import { useEffect, useRef } from 'react';
import { buildLandingWidgetConfig } from './landingWidgetConfig';
import { loadWidgetScript, removeWidgetScript } from './loadWidgetScript';

type WidgetApi = {
  destroy?: () => void;
};

export function LandingWidgetBridge() {
  const widgetApiRef = useRef<WidgetApi | null>(null);

  useEffect(() => {
    const runtimeConfig = buildLandingWidgetConfig(import.meta.env);
    if (!runtimeConfig) {
      console.error('[LandingWidgetBridge] Missing widget env config');
      return;
    }

    let cancelled = false;

    loadWidgetScript(runtimeConfig.scriptUrl)
      .then(() => {
        if (cancelled || widgetApiRef.current) {
          return;
        }

        const sdk = window.SmartCustomerService;
        if (!sdk) {
          console.error('[LandingWidgetBridge] SmartCustomerService is unavailable');
          return;
        }

        widgetApiRef.current = sdk.init(runtimeConfig.initConfig);
      })
      .catch((error) => {
        console.error('[LandingWidgetBridge] Failed to load widget script', error);
      });

    return () => {
      cancelled = true;
      try {
        widgetApiRef.current?.destroy?.();
      } catch (error) {
        console.warn('[LandingWidgetBridge] Failed to destroy widget', error);
      } finally {
        widgetApiRef.current = null;
      }
      removeWidgetScript();
    };
  }, []);

  return null;
}
